export default "__VITE_ASSET__DpHeoFDN__"